import "@/App.css";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Highlights from "@/components/Highlights";
import Menu from "@/components/Menu";
import Reviews from "@/components/Reviews";
import Info from "@/components/Info";
import Footer from "@/components/Footer";
import FloatingCall from "@/components/FloatingCall";

function App() {
  return (
    <div className="App grain bg-[#0f0f0f]">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Highlights />
        <Menu />
        <Reviews />
        <Info />
      </main>
      <Footer />
      <FloatingCall />
    </div>
  );
}

export default App;
